import React, { forwardRef, useState, useEffect } from 'react';
import { useForwardedRef, useEvent } from '@anton.bobrov/react-hooks';
import cx from 'classnames';

const LazyImage = forwardRef(
  ({ className, style, loading = "lazy", ...props }, forwardedRef) => {
    const ref = useForwardedRef(forwardedRef);
    const [isLoaded, setIsLoaded] = useState(false);
    const handleLoad = useEvent(() => setIsLoaded(true));
    useEffect(() => {
      if (!ref.current) {
        return;
      }
      if (ref.current.complete) {
        handleLoad();
      }
    }, [handleLoad, ref]);
    return /* @__PURE__ */ React.createElement(
      "img",
      {
        ...props,
        ref,
        className: cx("box", className),
        alt: props.alt,
        style: {
          ...style,
          "--preloader-opacity": isLoaded ? 1 : 0
        },
        loading,
        onLoad: handleLoad
      }
    );
  }
);
LazyImage.displayName = "LazyImage";

export { LazyImage };
//# sourceMappingURL=index.js.map
